import * as React from 'react';
import OrderAdditionalBanner from '../../OrderAdditionalBanner/OrderAdditionalBanner';
import { useSelector } from 'react-redux';
import css from './CompletedCheckinAdditionalBanner.css';
import { getCheckinHasCompleted } from '@websky/core/src/Modules/Checkin/store/order/selectors';
const CompletedCheckinAdditionalBanner = () => {
    const isConfirmed = useSelector(getCheckinHasCompleted);
    if (!isConfirmed) {
        return null;
    }
    return (React.createElement("div", { className: css.additionalBanner },
        React.createElement(OrderAdditionalBanner, { bookingUrl: 'https://redwings.vip-zal.ru/?utm_source=redwings&utm_medium=banner&utm_campaign=checkin&utm_content=top' })));
};
export default CompletedCheckinAdditionalBanner;
